<template>
  <div class="columns" style="height: 100%" v-if="!loading">
      <v-card class="column is-one-quarter" style="height: 100%">
        <v-subheader>Meine Fragen:</v-subheader>
              <v-list>
        <template v-for="(question, index) in questions">

        <v-list-item
          @click="questionSelected(question)"
          :key="index"
        >
          <v-list-item-content class="list-item">
            <v-list-item-title class="text-wrap">
              {{
              question.questionText
              }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              Gestellt von: {{ question.questionerFullName }}
              {{
              question.createdDate | moment("DD.MM.YYYY HH:mm")
              }}
            </v-list-item-subtitle>
          </v-list-item-content>

        </v-list-item>
        <v-divider :key="question.id" class="ma-0 pa-0" />
        </template>
        </v-list>
      </v-card>
    <div class="column">
      <AnswerQuestions
        v-if="selectedQuestion != null && !loading"
        :question="selectedQuestion"
        @questionAnswered="updateValues()"
      />
      <v-subheader v-else>Es sind gerade keine Fragen vorhanden</v-subheader>
    </div>
  </div>
</template>

<script>
import answerQuestionService from "./answer-question-service";
import AnswerQuestions from "./AnswerQuestions.vue";
export default {
  components: { AnswerQuestions },
  data: function() {
    return {
      questions: [],
      selectedQuestion: null,
      loading: true
    };
  },
  mounted() {
    this.retrieveQuestions();
  },
  methods: {
    retrieveQuestions() {
      answerQuestionService.retrieveUserQuestions().then(res => {
        this.questions = res.data;
        this.selectedQuestion = res.data[0];
        this.loading = false;
      });
    },
    questionSelected(question) {
      this.selectedQuestion = question;
    },
    updateValues() {
      this.selectedQuestion = null;
      this.retrieveQuestions();
    }
  }
};
</script>